import { getLocaleDecimalSeparator } from '#helper';

export const outputFormatOptions = {
  PDF: 'pdf',
  CSV: 'csv'
};

const buildPDFReportPath = ({
  applianceId,
  startDate,
  endDate,
  measurementSystem,
  selectedContentOptions
}) => {
  const contentOptionToQueryParameter = {
    locations: 'includeLocations',
    statisticalSummary: 'includeStatistics',
    measurementsTable: 'includeMetrics',
    temperatureChart: 'temperature',
    humidityChart: 'humidity'
  };

  const chartsOptions = {
    temperatureChart: 'temperature',
    humidityChart: 'humidity'
  };

  const chartsParams = [];

  const query = new URLSearchParams({
    measurementSystem
  });

  Object.entries(contentOptionToQueryParameter).forEach(([option, parameter]) => {
    if (selectedContentOptions[option]) {
      if (chartsOptions[option]) {
        chartsParams.push(parameter);
      } else {
        query.set(parameter, true);
      }
    }
  });

  if (chartsParams.length) {
    query.set('includeCharts', chartsParams);
  }

  return `report-external/appliance/${applianceId}/${startDate}/${endDate}?${query.toString()}`;
};

const buildCSVReportPath = ({
  applianceId,
  startDate,
  endDate,
  measurementSystem
}) => {
  const query = new URLSearchParams({
    system: measurementSystem
  });

  const decimalSeparator = getLocaleDecimalSeparator();

  if (decimalSeparator === ',') {
    query.set('decimalSeparator', 'comma');
  }

  return `report/csv/appliance/${applianceId}/${startDate}/${endDate}/?${query.toString()}`;
};

const buildReportPath = ({
  outputFormat,
  applianceId,
  startDate,
  measurementSystem,
  endDate,
  contentOptions
}) => {
  const selectedContentOptions = Object.fromEntries(
    contentOptions.map(({ name, checked }) => [name, checked])
  );

  if (outputFormat === outputFormatOptions.CSV) {
    return buildCSVReportPath({
      applianceId,
      startDate,
      endDate,
      measurementSystem
    });
  }

  return buildPDFReportPath({
    applianceId,
    startDate,
    endDate,
    measurementSystem,
    selectedContentOptions
  });
};

export default buildReportPath;
